import { RebaseTranslations } from "@rebasepro/cms-types";

export const de: RebaseTranslations = {
    // ─── Form actions ────────────────────────────────────────────
    save: "Speichern",
    create: "Erstellen",
    create_copy: "Kopie erstellen",
    save_and_close: "Speichern und schließen",
    create_copy_and_close: "Kopie erstellen und schließen",
    create_and_close: "Erstellen und schließen",
    discard: "Verwerfen",
    clear: "Löschen",
    cancel: "Abbrechen",

    // ─── Entity actions ──────────────────────────────────────────
    edit: "Bearbeiten",
    copy: "Kopieren",
    delete: "Löschen",
    delete_not_allowed: "Sie haben mindestens eine Entität ausgewählt, die Sie nicht löschen können",
    edit_entity: "Bearbeiten",
    back_to_detail: "Zurück zu den Details",

    // ─── Delete dialog ───────────────────────────────────────────
    delete_confirmation_title: "Löschen?",
    delete_confirmation_body: "Dadurch wird die Entität gelöscht. Sind Sie sicher?",
    delete_multiple_confirmation_body: "Dadurch werden die ausgewählten Entitäten gelöscht. Sind Sie sicher?",

    // ─── Unsaved-changes dialog ───────────────────────────────────
    unsaved_changes_title: "Ungespeicherte Änderungen",
    unsaved_changes_body: "Sie haben ungespeicherte Änderungen. Möchten Sie diese verwerfen?",
    discard_changes: "Änderungen verwerfen",
    keep_editing: "Weiter bearbeiten",
    clear_form: "Formular leeren?",
    discard_changes_confirmation: "Alle nicht gespeicherten Änderungen gehen verloren. Dies kann nicht rückgängig gemacht werden.",
    clear_form_confirmation: "Alle eingegebenen Werte werden gelöscht. Dies kann nicht rückgängig gemacht werden.",

    // ─── Collection table / toolbar ──────────────────────────────
    search: "Suchen",
    find_by_id: "Nach ID suchen",
    find_entity_by_id: "Entität nach ID suchen",
    filter: "Filter",
    filters: "Filter",
    records_in_view: "Datensätze in dieser Ansicht",
    clear_filter: "Filter löschen",
    clear_filter_sort: "Filter/Sortierung löschen",
    clear_sort: "Sortierung löschen",
    sort: "Sortieren",
    sort_by: "Sortieren nach",
    sort_then_by: "Dann nach",
    sort_ascending: "Aufsteigend sortieren",
    sort_descending: "Absteigend sortieren",
    sort_remove: "Sortierung entfernen",
    sort_move_up: "Diesen Schlüssel wichtiger machen",
    sort_move_down: "Diesen Schlüssel weniger wichtig machen",
    sort_remove_key: "Diesen Sortierschlüssel entfernen",
    sort_key_position: "Sortierschlüssel {{position}}",
    sort_shift_click_hint: "Umschalt+Klick, um eine Spalte unter der aktuellen Sortierung hinzuzufügen",
    save_entity_before_subcollections: "Du musst den Eintrag speichern, bevor du weitere Sammlungen hinzufügst",
    clear_all: "Alle löschen",
    no_items: "Keine Elemente",
    no_entries_found: "Keine Einträge gefunden",
    all_entries_loaded: "Alle {{count}} Einträge geladen",
    create_your_first_entry: "Erstellen Sie Ihren ersten Eintrag",
    no_results_filter_sort: "Keine Ergebnisse mit angewendetem Filter/Sortierung",
    no_results_search: "Keine Ergebnisse gefunden für \"{{search}}\"",
    add: "Hinzufügen",
    remove: "Entfernen",
    multiple_entities: "Mehrere Entitäten",
    unsaved_changes: "Sie haben ungespeicherte Änderungen in {{collectionName}}.",
    so_empty: "So leer...",
    no_results: "Keine Ergebnisse mit angewendetem Filter/Sortierung",
    refresh_data: "Daten aktualisieren",
    dark_mode: "Dunkel",
    light_mode: "Hell",
    system_mode: "System",
    join_newsletter: "Newsletter abonnieren, kein Spam",
    ok: "Ok",
    save_collection_config: "Sammlungsstruktur speichern",
    search_for_more_icons: "Nach weiteren Symbolen suchen…",
    ai_modified: "KI-modifiziert",
    size_label: "Größe",
    group_by: "Gruppieren nach",
    initialize_kanban_order: "Kanban-Reihenfolge initialisieren",
    copy_id: "ID kopieren",
    add_specific: "{{name}} hinzufügen",
    add_named: "\"{{name}}\" hinzufügen",
    select_specific: "{{name}} auswählen",
    select_from: "Aus {{name}} auswählen",
    done: "Fertig",
    log_out: "Abmelden",
    column_cannot_be_edited: "Diese Spalte kann nicht direkt bearbeitet werden",
    close: "Schließen",
    hide_list: "Liste ausblenden",
    show_list: "Liste einblenden",
    unsaved_local_changes: "Ungespeicherte lokale Änderungen",
    unsaved_local_changes_description: "Dieses Dokument wurde lokal bearbeitet und weist ungespeicherte Änderungen auf. Diese lokalen Änderungen gehen verloren, wenn Sie sie nicht anwenden.",
    preview_changes: "Änderungen in der Vorschau anzeigen",
    apply_changes: "Änderungen anwenden",
    discard_local_changes: "Lokale Änderungen verwerfen",
    preview_local_changes: "Lokale Änderungen in der Vorschau anzeigen",
    preview_local_changes_description: "Dies sind die lokalen Änderungen, die auf das Formular angewendet werden.",
    type: "Typ",
    string: "Zeichenfolge",
    number: "Zahl",
    boolean: "Boolescher Wert",
    date: "Datum",
    map: "Karte",
    array: "Array",
    arrays_of_arrays_not_supported: "Arrays von Arrays werden nicht unterstützt.",
    data_type_not_supported: "Datentyp {{dataType}} wird noch nicht unterstützt",
    passkey_error_unsupported: "Ihr Gerät oder Browser unterstützt keine Passkeys.",

    // ─── Entity form feedback ─────────────────────────────────────
    saved_correctly: "Erfolgreich gespeichert",
    error_before_saving: "Fehler bei der Datenvorbereitung",
    error_after_saving: "Fehler im Nachspeichervorgang",
    error_saving_entity: "Fehler beim Speichern des Eintrags",
    entity_does_not_exist: "Dieser Eintrag existiert nicht in der Datenbank",
    form_modified: "Dieses Formular wurde geändert",
    form_in_sync: "Das aktuelle Formular ist mit der Datenbank synchron",
    fix_errors_before_saving: "Markierte Fehler vor dem Speichern beheben",

    admin: "Admin",
    home: "Startseite",
    this_form_has_errors: "Dieses Formular enthält Fehler",
    error_loading_navigation: "Fehler beim Laden der Navigation",
    error_loading_auth: "Fehler beim Laden der Authentifizierung",
    this_form_has_been_modified: "Dieses Formular wurde geändert",
    current_form_in_sync: "Das aktuelle Formular ist mit der Datenbank synchron",
    open_in_console: "In der Konsole öffnen",
    collection_does_not_exist: "Die angegebene Sammlung existiert nicht. Überprüfen Sie die Konsole",
    unexpected_value: "Unerwarteter Wert",
    unexpected_value_click_to_edit: "Unerwarteter Wert. Klicken zum Bearbeiten",
    unexpected_reference_value: "Unerwarteter Referenzwert. Klicken zum Bearbeiten",
    copy_url_to_clipboard: "URL in Zwischenablage kopieren",
    open_image_in_new_tab: "Bild in neuem Tab öffnen",
    reference_not_set: "Referenz nicht gesetzt",
    reference_does_not_exist: "Referenz existiert nicht",
    entity_not_found: "Entität nicht gefunden",
    entity_not_found_body: "Dieser Datensatz existiert nicht, oder er ist durch die Sicherheit auf Zeilenebene für Sie nicht sichtbar.",
    back_to_collection: "Zurück zu {{name}}",
    file_not_found: "Datei nicht gefunden",
    unsaved_changes_in_entity: "Sie haben ungespeicherte Änderungen in dieser Entität.",
    delete_this_role: "Diese Rolle löschen",
    no_roles_yet: "Sie haben noch keine Rollen.",
    create_default_roles: "Standardrollen erstellen",
    delete_role_confirmation: "Sind Sie sicher, dass Sie diese Rolle löschen möchten?",
    delete_this_user: "Diesen Benutzer löschen",
    no_users_yet: "Es gibt noch keine Benutzer",
    add_logged_user_as_admin: "Den angemeldeten Benutzer als Administrator hinzufügen",
    add_current_user_as_admin: "Aktuellen Benutzer als Administrator hinzufügen",
    create_default_roles_and_add_admin: "Standardrollen erstellen und aktuellen Benutzer als Administrator hinzufügen",
    delete_user_confirmation: "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?",
    create_your_users_and_roles: "Erstellen Sie Ihre Benutzer und Rollen",
    no_users_or_roles_defined: "Sie haben keine Benutzer oder Rollen definiert. Sie können Standardrollen erstellen und den aktuellen Benutzer als Administrator hinzufügen.",
    save_before_changing_schema: "Sie müssen das Dokument speichern, bevor Sie das Schema ändern können",
    edit_schema_for_this_form: "Schema für dieses Formular bearbeiten",
    no_permissions_to_edit_collection: "Sie haben keine Berechtigung, diese Sammlung zu bearbeiten",
    browser_does_not_support_audio: "Ihr Browser unterstützt das Audioelement nicht.",
    user_not_found: "Benutzer nicht gefunden: {{value}}",

    // ─── Collection view actions ──────────────────────────────────
    delete_selected: "Löschen",
    cannot_delete_selected: "Sie haben mindestens eine Entität ausgewählt, die Sie nicht löschen können",

    // ─── Array / field containers ─────────────────────────────────
    add_entry: "Hinzufügen",
    add_on_top: "Oben hinzufügen",
    add_below: "Unten hinzufügen",
    add_to_field: "Zu {{fieldName}} hinzufügen",
    value: "Wert",
    key: "Schlüssel",
    drag_drop_multiple: "Ziehen Sie einige Dateien hierher oder klicken Sie, um Dateien auszuwählen. Ziehen zum Neuordnen.",
    drag_drop_single: "Ziehen Sie eine Datei hierher oder klicken Sie, um eine auszuwählen",

    // ─── Navigation / scaffold ────────────────────────────────────
    open_menu: "Menü öffnen",
    close_drawer: "Schublade schließen",
    navigation_drawer: "Navigationsschublade",
    collapse: "Einklappen",
    expand: "Ausklappen",
    change_language: "Sprache ändern",
    toggle_theme: "Design umschalten",
    user_menu: "Benutzermenü",

    // ─── Error states ─────────────────────────────────────────────
    error: "Fehler",
    error_loading_data: "Daten konnten nicht geladen werden",
    error_check_server_logs: "Weitere Details finden Sie in den Serverprotokollen.",
    error_technical_details: "Technische Details",
    error_uploading_file: "Fehler beim Hochladen der Datei",
    error_deleting: "Fehler beim Löschen",
    error_before_delete: "Fehler vor dem Löschen",
    error_updating_asset: "Fehler beim Aktualisieren des Assets",
    error_deleting_asset: "Fehler beim Löschen des Assets",
    error_firestore_index: "Für diese Abfrage ist ein Firestore-Index erforderlich.",
    create_index: "Index erstellen",
    value_is_not_reference: "Wert ist keine Referenz.",
    click_to_edit: "Klicken zum Bearbeiten",
    data_is_not_array_of_references: "Daten sind kein Array von Referenzen",

    // ─── Misc ─────────────────────────────────────────────────────
    loading: "Wird geladen",
    local_changes_applied: "Lokale Änderungen auf das Formular angewendet",
    local_changes_discarded: "Lokale Änderungen verworfen",
    are_you_sure_leave: "Sind Sie sicher, dass Sie diese Seite verlassen möchten?",
    see_console_details: "Weitere Details siehe Konsole.",
    drop_here_create_group: "Hier ablegen, um eine neue Gruppe zu erstellen",
    filter_for_null_values: "Nach Nullwerten filtern",
    value_updated_elsewhere: "Dieser Wert wurde anderswo aktualisiert",
    add_property: "Eigenschaft hinzufügen",
    edit_name: "Bearbeiten {{name}}",
    this_entity_not_exist: "Diese Entität existiert nicht in der Datenbank",
    internal_error: "Interner FEHLER",

    // ─── Rename group dialog ──────────────────────────────────────
    rename_group: "Gruppe umbenennen",
    group_name_label: "Gruppenname",
    group_name_empty_error: "Gruppenname darf nicht leer sein.",
    group_name_exists_error: "Dieser Gruppenname existiert bereits.",

    // ─── Search ───────────────────────────────────────────────────
    search_collections: "Sammlungen durchsuchen",

    // ─── Navigation groups ────────────────────────────────────────
    views_group: "Ansichten",

    // ─── Entity Edit View ─────────────────────────────────────────
    youd_need_to_save_before_additional_collections: "Sie müssen Ihre Entität speichern, bevor Sie weitere Sammlungen hinzufügen können",

    // ─── Not Found Page ───────────────────────────────────────────
    page_not_found: "Seite nicht gefunden",
    page_not_found_body: "Diese Seite existiert nicht oder Sie haben möglicherweise keinen Zugriff darauf",
    back_to_home: "Zurück zur Startseite",

    // ─── Collection Editor ─────────────────────────────────────────
    default_collection_view: "Standard-Sammlungsansicht",
    table_view: "Tabelle",
    cards_view: "Karten",
    kanban_view: "Kanban",
    choose_how_entities_displayed_default: "Wählen Sie aus, wie Entitäten standardmäßig angezeigt werden sollen",

    document_view: "Dokumentenansicht",
    side_panel: "Seitenbereich",
    full_screen: "Vollbild",
    should_documents_opened_full_screen: "Sollen Dokumente im Vollbildmodus oder in einem Inline-Seitendialog geöffnet werden",

    select_custom_view: "Benutzerdefinierte Ansicht auswählen",
    no_custom_views_defined: "Keine benutzerdefinierten Ansichten definiert. Definieren Sie Ihre benutzerdefinierten Ansichten in den Anpassungseinstellungen, bevor Sie diesen Dialog verwenden.",

    select_custom_action: "Benutzerdefinierte Aktion auswählen",
    no_custom_actions_defined: "Keine benutzerdefinierten Aktionen definiert. Definieren Sie Ihre benutzerdefinierten Aktionen in den Anpassungseinstellungen, bevor Sie diesen Dialog verwenden.",

    no_collections_found: "Keine Sammlungen gefunden",
    start_building_collections: "Beginnen Sie einfach mit dem Erstellen von Sammlungen in Rebase. Ordnen Sie sie Ihren bestehenden Datenbankdaten zu, importieren Sie sie aus Dateien oder verwenden Sie unsere Vorlagen.",
    create_first_collection: "Erstellen Sie Ihre erste Sammlung",
    define_collections_programmatically: "Sie können Sammlungen auch programmgesteuert definieren.",
    edit_collection: "Sammlung bearbeiten",
    no_permissions_edit_collection: "Sie haben keine Berechtigung, diese Sammlung zu bearbeiten",
    no_permissions_create_collection: "Sie haben keine Berechtigung, Sammlungen zu erstellen",
    create_collection: "Sammlung erstellen",
    update_collection: "Sammlung aktualisieren",

    new_collection: "Neue Sammlung",
    add_new_collection: "Neue Sammlung hinzufügen",
    collection_with_name: "Sammlung {{name}}",
    change_icon: "Symbol ändern",
    is_subcollection_of: "Dies ist eine Untersammlung von",
    name: "Name",
    collection_name_description: "Name dieser Sammlung, normalerweise im Plural (z. B. Produkte)",
    path: "Pfad",
    relative_path_to_parent: "Relativer Pfad zum übergeordneten Element (der übergeordnete Pfad muss nicht eingeschlossen werden)",
    path_in_database: "Pfad, in dem diese Sammlung in der Datenbank gespeichert ist",
    singular_name: "Bezeichnung im Singular",
    singular_name_description: "Definieren Sie optional einen Singularnamen für Ihre Entitäten",
    description: "Beschreibung",
    description_of_collection: "Beschreibung der Sammlung, Sie können Markdown verwenden",
    collection_id: "Sammlungs-ID",
    collection_id_description: "Diese ID identifiziert diese Sammlung. Typischerweise identisch mit dem Pfad.",
    collection_group: "Sammlungsgruppe",
    collection_group_description: "Eine Sammlungsgruppe besteht aus allen Sammlungen mit demselben Pfad. Auf diese Weise können Sie über mehrere Sammlungen gleichzeitig abfragen.",
    advanced_settings: "Erweiterte Einstellungen",
    doc_history_global: "Dokumentverlaufsrevisionen aktiviert, falls global aktiviert",
    doc_history_enabled: "Dokumentverlaufsrevisionen AKTIVIERT",
    doc_history_not_enabled: "Dokumentverlaufsrevisionen NICHT aktiviert",
    doc_history_description: "Wenn diese Option aktiviert ist, verfügt jedes Dokument in dieser Sammlung über einen Änderungsverlauf. Dies ist nützlich für Überwachungszwecke. Die Daten werden in einer Untersammlung des Dokuments in Ihrer Datenbank namens __history gespeichert.",
    document_id_generation: "Generierung von Dokument-IDs",
    code_defined: "Code definiert",
    users_must_define_id: "Benutzer müssen eine ID definieren",
    users_can_define_id: "Benutzer können eine ID definieren, dies ist jedoch nicht erforderlich",
    doc_id_auto_generated: "Dokument-ID wird automatisch generiert",
    config_doc_id_generation: "Konfigurieren Sie, wie Dokument-IDs beim Erstellen neuer Entitäten generiert werden.",
    enable_text_search: "Textsuche für diese Sammlung aktivieren",
    text_search_description: "Erlauben Sie die Textsuche für diese Sammlung. Wenn Sie keinen Delegaten für die Textsuche angegeben haben, wird die integrierte lokale Textsuche verwendet. Dies wird für große Sammlungen nicht empfohlen, da dies zu Leistungs- und Kostenproblemen führen kann.",
    database_id: "Datenbank-ID",
    default_text: "(Standard)",

    custom_actions: "Benutzerdefinierte Aktionen",
    more_info: "Mehr Infos",
    define_custom_actions_cli: "Definieren Sie Ihre eigenen benutzerdefinierten Aktionen, indem Sie sie mit der CLI hochladen.",
    action_defined_in_code: "Diese Aktion ist im Code definiert mit dem Schlüssel",
    add_custom_entity_action: "Benutzerdefinierte Entitätsaktion hinzufügen",
    remove_this_action: "Diese Aktion entfernen?",
    remove_action_warning: "Dadurch werden keine Daten gelöscht, sondern nur die Aktion im Admin-Panel",

    subcollections_of: "Untersammlungen von",
    add_subcollection: "Untersammlung hinzufügen",
    custom_views: "Benutzerdefinierte Ansichten",
    define_custom_views_cli: "Definieren Sie Ihre eigenen benutzerdefinierten Ansichten, indem Sie sie mit der CLI hochladen.",
    view_defined_in_code: "Diese Ansicht ist im Code definiert mit dem Schlüssel",
    add_custom_entity_view: "Benutzerdefinierte Entitätsansicht hinzufügen",
    delete_this_subcollection: "Diese Untersammlung löschen?",
    remove_collection_warning: "Dadurch werden keine Daten gelöscht, sondern nur die Sammlung im Admin-Panel",
    remove_this_view: "Diese Ansicht entfernen?",
    remove_view_warning: "Dadurch werden keine Daten gelöscht, sondern nur die Ansicht im Admin-Panel",

    no_collection_selected: "Keine Sammlung ausgewählt",
    code_for_collection: "Code für",
    use_config_define_json: "Verwenden Sie diese Konfiguration, um die Sammlung im JSON-Format zu definieren.",
    customise_collection_code: "Wenn Sie die Sammlung im Code anpassen möchten, können Sie diesen Sammlungscode zu Ihrer Admin-App-Konfiguration hinzufügen.",
    copied: "Kopiert",

    property_cant_be_edited: "Diese Eigenschaft kann nicht bearbeitet werden",
    property_not_editable_description: "Sie haben möglicherweise keine Berechtigung zum Bearbeiten oder es ist im Code definiert und kann nicht geändert werden.",
    delete_this_property: "Diese Eigenschaft löschen?",
    delete_property_warning: "Dadurch werden keine Daten gelöscht, nur die Sammlung wird geändert.",
    error_must_specify_id: "Sie müssen eine ID für das Feld angeben",
    error_id_format: "Die ID darf nur Buchstaben, Zahlen und Unterstriche (_) enthalten und nicht mit einer Zahl beginnen",
    error_id_already_exists: "Es gibt bereits ein anderes Feld mit dieser ID",
    error_must_specify_title: "Sie müssen einen Titel für das Feld angeben",
    custom_or_other: "Benutzerdefiniert/Andere",
    select_property_widget: "Wählen Sie ein Eigenschafts-Widget aus",
    error_changing_data_type: "Dieses Widget verwendet einen anderen Datentyp als das ursprünglich ausgewählte Widget. Dies kann zu Fehlern bei vorhandenen Daten führen.",
    required: "Erforderlich",

    enum_form_dialog: "Enum-Formulardialog",
    imported_data_preview: "Vorschau der importierten Daten",
    entities_with_same_id_overwritten: "Entitäten mit derselben ID werden überschrieben",
    collection_editor: "Sammlungseditor",
    properties_in_this_group: "Eigenschaften in dieser Gruppe",
    data_property_mapping: "Daten-Eigenschafts-Zuordnung",
    property_edit_view: "Ansicht Eigenschaft bearbeiten",
    all_of_these: "Alle von diesen",
    any_of_these: "Eine von diesen",

    only_admins_edit_roles: "Nur Administratoren können Rollen bearbeiten",
    error_user_not_found: "Benutzer nicht gefunden",
    all_roles: "Alle Rollen",
    role: "Rolle",
    name_of_this_role: "Name dieser Rolle",
    id_of_this_role: "ID dieser Rolle",
    create_entities: "Entitäten erstellen",
    read_entities: "Entitäten lesen",
    update_entities: "Entitäten aktualisieren",
    delete_entities: "Entitäten löschen",
    all_collections: "Alle Sammlungen",
    create_entities_in_collections: "Entitäten in Sammlungen erstellen",
    access_all_data_in_every_collection: "Auf alle Daten in jeder Sammlung zugreifen",
    update_data_in_any_collection: "Daten in einer beliebigen Sammlung aktualisieren",
    delete_data_in_any_collection: "Daten in einer beliebigen Sammlung löschen",
    allow_all_permissions_in_this_collections: "Alle Berechtigungen in diesen Sammlungen zulassen",
    all: "Alle",
    customise_permissions_description: "Sie können die Berechtigungen anpassen, die die mit dieser Rolle verknüpften Benutzer für die Entitäten jeder Sammlung ausführen können",
    create_collections: "Sammlungen erstellen",
    yes: "Ja",
    no: "Nein",
    can_user_create_collections: "Kann der Benutzer Sammlungen erstellen",
    edit_collections: "Sammlungen bearbeiten",
    only_own_collections: "Nur seine/ihre eigenen",
    own: "Eigene",
    can_user_edit_collections: "Kann der Benutzer Sammlungen bearbeiten",
    delete_collections: "Sammlungen löschen",
    can_user_delete_collections: "Kann der Benutzer Sammlungen löschen",
    error_saving_role: "Beim Speichern dieser Rolle ist ein Fehler aufgetreten",
    create_role: "Rolle erstellen",
    update: "Aktualisieren",

    only_admins_change_roles: "Nur Administratoren können Rollen ändern",
    must_be_at_least_one_admin: "Es muss mindestens einen Administrator geben",
    logged_user_not_found: "Angemeldeter Benutzer nicht gefunden",
    user: "Benutzer",
    user_id: "Benutzer-ID",
    name_of_this_user: "Name dieses Benutzers",
    email_of_this_user: "E-Mail dieses Benutzers",
    roles: "Rollen",
    create_user: "Benutzer erstellen",

    users: "Benutzer",
    add_user: "Benutzer hinzufügen",
    add_role: "Rolle hinzufügen",
    is_admin: "Ist Administrator",
    default_permissions: "Standardberechtigungen",
    created_on: "Erstellt am",
    email: "E-Mail",
    id: "ID",
    read: "Lesen",

    column_in_file: "Spalte in der Datei",
    map_to_property: "Zuordnung zur Eigenschaft",
    default_values: "Standardwerte",
    default_values_description: "Sie können einen Standardwert für nicht zugeordnete Spalten und leere Werte auswählen:",
    property: "Eigenschaft",
    default_value: "Standardwert",
    autogenerate_id: "ID automatisch generieren",
    id_column_description: "Spalte, die als ID für jedes Dokument verwendet wird",
    do_not_set_value: "Wert nicht festlegen",
    set_value_to_true: "Wert auf true setzen",
    set_value_to_false: "Wert auf false setzen",
    drag_and_drop_file: "Datei hierher ziehen und ablegen oder zum Hochladen klicken",
    error_saving_data: "Fehler beim Speichern der Daten",
    retry: "Wiederholen",
    saving_data: "Daten speichern",
    entities_saved: "Entitäten gespeichert",
    do_not_close_tab: "Schließen Sie diesen Tab nicht, da sonst der Import unterbrochen wird",
    import: "Importieren",
    import_data: "Daten importieren",
    upload_file_description: "Laden Sie eine CSV-, Excel- oder JSON-Datei hoch und ordnen Sie sie Ihrem vorhandenen Schema zu",
    back: "Zurück",
    next: "Weiter",
    save_data: "Daten speichern",
    use_column_as_id: "Diese Spalte als ID verwenden",
    do_not_import_property: "Diese Eigenschaft nicht importieren",
    entities_will_be_overwritten: "Entitäten mit derselben ID werden überschrieben",
    data_imported_successfully: "Daten erfolgreich importiert",
    export: "Exportieren",
    export_data: "Daten exportieren",
    download_table_csv: "Laden Sie den Inhalt dieser Tabelle als CSV-Datei herunter",
    csv: "CSV",
    json: "JSON",
    dates_as_timestamps: "Daten als Zeitstempel",
    dates_as_strings: "Daten als Zeichenfolgen",
    flatten_arrays: "Arrays glätten",
    download: "Herunterladen",
    large_number_of_documents: "Diese Sammlung hat eine große Anzahl von Dokumenten ({{count}}).",
    too_many_documents_to_export: "Diese Sammlung enthält mehr Dokumente ({{count}}), als der Browser in einer einzigen Datei exportieren kann (Grenze {{limit}}). Filtern Sie sie vor dem Export.",
    include_undefined_values: "Undefinierte Werte einschließen",
    submit: "Einreichen",

    no_filterable_properties: "Keine filterbaren Eigenschaften verfügbar",
    apply_filters: "Filter anwenden",

    // ─── Filter Presets ──────────────────────────────────────────
    filter_presets: "Vorlagen",
    filter_preset_apply: "Vorlage anwenden",
    filter_preset_active: "Aktiv: {{label}}",

    list: "Liste",
    table_view_mode: "Tabelle",
    cards: "Karten",
    board: "Board",
    initialize_kanban_order_desc: "Dadurch werden allen Elementen, die keine haben, fortlaufende Auftragswerte zugewiesen. Die Elemente behalten ihre aktuelle Reihenfolge innerhalb jeder Spalte bei.",
    kanban_view_not_available: "Kanban-Ansicht ist nicht verfügbar",
    kanban_view_requires_enum: "Die Kanban-Ansicht erfordert eine String-Eigenschaft mit Enum-Werten, um Entitäten in Spalten zu gruppieren. Bitte fügen Sie dem Schema Ihrer Sammlung eine Enum-Eigenschaft hinzu, um diese Ansicht zu verwenden.",
    no_enum_values_configured: "Keine Enum-Werte für Eigenschaft \"{{property}}\" konfiguriert",
    items_need_backfill: "Einige Elemente haben keine Reihenfolge. Initialisieren Sie sie, um das Verschieben per Drag-and-Drop zu aktivieren.",
    kanban_order_not_configured: "Die Drag-and-Drop-Sortierung ist nicht konfiguriert. Legen Sie eine Ordnungseigenschaft in den Sammlungseinstellungen fest, um die Kartenpositionen zu speichern.",
    initialize: "Initialisieren",
    confirm_multiple_delete: "Mehrfaches Löschen bestätigen?",
    delete_entity_confirm_title: "Möchten Sie dieses {{entityName}} löschen?",
    add_existing: "Vorhandenes hinzufügen",
    unlink_entity_confirm_title: "Dieses {{entityName}} aus diesem Datensatz entfernen?",
    unlink_entity_confirm_body: "Es bleibt in {{collectionName}} und steht anderen Datensätzen weiterhin zur Verfügung.",
    confirm_multiple_unlink: "diese aus diesem Datensatz entfernen?",
    no_filter: "Kein Filter",
    is_true: "ist wahr",
    is_false: "ist falsch",
    error_uploading_file_size: "Fehler beim Hochladen: Die Datei ist größer als {{maxSize}} Bytes",
    error_uploading_file_type: "Fehler beim Hochladen: Dieser Dateityp wird nicht unterstützt",
    drag_drop_files: "Dateien hierher ziehen oder hier klicken, um sie zu bearbeiten",
    drag_drop_file: "Datei hierher ziehen oder hier klicken, um sie zu bearbeiten",
    multiple_deleted: "Mehrere gelöscht",
    some_entities_deleted: "Einige der Entitäten wurden gelöscht, aber nicht alle",
    error_deleting_entities: "Fehler beim Löschen der Entitäten",
    deleted: "gelöscht",
    selection_options: "Auswahloptionen",
    selection_menu_all_loaded: "Alle auf dieser Seite",
    selection_menu_all_matching: "Alle {{total}} {{collection}}",
    selection_menu_none: "Keine",
    selection_select_all_loaded: "Geladene Zeilen auswählen",
    selection_deselect_all: "Alle abwählen",
    selection_reading_rows: "Zeilen werden gelesen… {{loaded}} von {{total}}",
    selection_reading_rows_unknown: "Zeilen werden gelesen… bisher {{loaded}}",
    selection_deleting_progress: "{{completed}} von {{total}} gelöscht",
    confirm_delete_selection: "{{total}} {{collection}} löschen?",
    confirm_delete_selection_unknown: "Alle Zeilen löschen, die dem aktuellen Filter entsprechen?",
    confirm_delete_selection_body: "Dies kann nicht rückgängig gemacht werden. Jede Zeile wird einzeln gelöscht, das kann eine Weile dauern.",

    export_selection_count: "Die {{total}} ausgewählten Zeilen als {{format}} herunterladen",
    export_selection_all_matching: "Alle {{collection}}, die dem aktuellen Filter entsprechen, herunterladen",

    select_reference: "Referenz auswählen",
    select_references: "Referenzen auswählen",
    account_settings: "Kontoeinstellungen",
    profile: "Profile",
    security: "Sicherheit",
    sessions: "Sessions",
    change_password: "Passwort ändern",
    current_password: "Aktuelles Passwort",
    new_password: "Neues Passwort",
    confirm_password: "Neues Passwort bestätigen",
    password_changed: "Passwort erfolgreich geändert. Sie werden abgemeldet.",
    passwords_dont_match: "Die Passwörter stimmen nicht überein",
    password_too_short: "Das Passwort muss mindestens 8 Zeichen lang sein",
    password_change_not_available: "Für Konten mit externem Anmeldeanbieter ist die Passwortänderung nicht verfügbar.",
    changing_password: "Wird geändert …",
    display_name: "Anzeigename",
    photo_url: "Foto-URL",
    save_profile: "Profil speichern",
    saving: "Saving...",
    no_active_sessions: "Keine aktiven Sitzungen gefunden.",
    revoking: "Revoking...",
    revoke_all_sessions: "Alle Sitzungen widerrufen",
    unknown_device: "Unbekanntes Gerät",
    current: "Current",
    role_id: "Rollen-ID",
    role_name: "Rollenname",
    add_reference: "Referenz hinzufügen",
    add_reference_to: "Referenz zu {{name}} hinzufügen",

    /** RolesView — table & permissions */
    role_deleted_successfully: "Rolle erfolgreich gelöscht",
    error_deleting_role: "Fehler beim Löschen der Rolle",
    collection_permissions: "Berechtigungen der Sammlung",
    collection: "Collection",
    no_collections_configured: "Keine Sammlungen konfiguriert",
    no_security_rules_defined: "Keine Sicherheitsregeln definiert — alle Vorgänge sind uneingeschränkt",
    no_rules: "keine Regeln",

    /** UsersView — snackbar */
    bootstrap_admin_success: "Sie sind jetzt Administrator! Wird aktualisiert …",
    failed_to_bootstrap_admin: "Administrator konnte nicht eingerichtet werden",
    user_deleted_successfully: "Benutzer erfolgreich gelöscht",
    error_deleting_user: "Fehler beim Löschen des Benutzers",
    user_created_successfully: "Benutzer erfolgreich erstellt",
    invitation_sent: "Eine Einladungs-E-Mail wurde an {{email}} gesendet. Über den Link kann das Passwort gesetzt werden.",
    invitation_sent_title: "Einladung gesendet",
    temporary_password: "Temporäres Passwort",
    temporary_password_description: "E-Mail ist nicht konfiguriert. Geben Sie dieses temporäre Passwort sicher an den Benutzer weiter. Es wird nicht erneut angezeigt.",
    temporary_password_email_failed_description: "Die E-Mail konnte nicht zugestellt werden. Geben Sie dieses temporäre Passwort sicher an den Benutzer weiter. Es wird nicht erneut angezeigt.",
    copy_password: "Passwort kopieren",
    password_copied: "Passwort in die Zwischenablage kopiert",

    /** UsersView — pagination & search */
    search_users: "Benutzer suchen",
    created: "Erstellt",
    actions: "Aktionen",
    no_users_found: "Keine Benutzer gefunden",
    reset_password: "Passwort zurücksetzen",
    reset_password_success: "Passwort erfolgreich zurückgesetzt",
    reset_password_confirmation: "Möchten Sie das Passwort dieses Benutzers wirklich zurücksetzen?",
    reset_password_send_email: "E-Mail zum Zurücksetzen des Passworts senden",
    reset_password_set_manually: "Passwort manuell setzen",
    reset_password_set_manually_description: "Das Passwort wird sofort geändert und es wird keine E-Mail gesendet. Geben Sie es sicher an den Benutzer weiter.",

    /** Permission-denied empty states */
    no_permission_to_view_users: "Sie haben keine Berechtigung, Benutzer anzuzeigen",
    no_permission_to_view_roles: "Sie haben keine Berechtigung, Rollen anzuzeigen",
    no_permission_description: "Wenden Sie sich an einen Administrator, wenn Sie Zugang zu diesem Bereich benötigen.",
    error_resetting_password: "Fehler beim Zurücksetzen des Passworts",

    /** Editor table-bubble */
    add_row_before: "Zeile davor einfügen",
    add_row_after: "Zeile danach einfügen",
    delete_row: "Zeile löschen",
    add_column_before: "Spalte davor einfügen",
    add_column_after: "Spalte danach einfügen",
    delete_column: "Spalte löschen",
    delete_table: "Tabelle löschen",

    /** Editor image-bubble */
    alt_text: "Alternativtext",
    title: "Title",

    /** MapFieldBinding */
    a_property_of_this_map_has_error: "Eine Eigenschaft dieser Zuordnung enthält einen Fehler",

    /** AI Collection Generator Popover */
    generate_collection_with_ai: "Sammlung mit KI generieren",
    modify_collection_with_ai: "Sammlung mit KI ändern",
    describe_collection_to_create: "Beschreibe die Sammlung, die du erstellen möchtest.",
    describe_changes_to_make: "Beschreibe die Änderungen, die du an dieser Sammlung vornehmen möchtest.",
    ai_placeholder_create: "z. B. Erstelle eine Produktsammlung mit Name, Preis, Beschreibung und Kategorie...",
    ai_placeholder_modify: "z. B. Füge ein Miniaturbild-Feld mit Speicher hinzu, mache den Preis erforderlich...",
    ai_assist: "KI-Assistent",
    generating: "Generiere...",

    /** Recently extracted strings for collection editor */
    this_is_subcollection_of: "Dies ist eine Untersammlung von",
    use_existing_paths_database: "Verwenden Sie einen der vorhandenen Pfade in Ihrer Datenbank:",
    describe_collection_ai: "Beschreiben Sie Ihre Sammlung für KI:",
    generate_with_ai: "Mit KI generieren",
    create_from_json_config: "Aus JSON-Konfiguration erstellen:",
    paste_json_config: "JSON-Konfiguration einfügen",
    create_collection_from_file_formats: "Eine Sammlung aus einer Datei erstellen (csv, json, xls, xslx...)",
    select_template: "Wählen Sie eine Vorlage:",
    products: "Produkte",
    collection_products_subtitle: "Eine Sammlung von Produkten mit Bildern, Preisen und Lagerbestand",
    collection_users_subtitle: "Eine Sammlung von Benutzern mit E-Mails, Namen und Rollen",
    blog_posts: "Blogbeiträge",
    collection_blog_posts_subtitle: "Eine Sammlung von Blogbeiträgen mit Bildern, Autoren und komplexen Inhalten",
    pages: "Seiten",
    collection_pages_subtitle: "Eine Sammlung von Seiten mit Bildern, Autoren und komplexen Inhalten",
    continue_from_scratch: "Von vorne beginnen",

    /** Admin views config */
    admin_users: "Admin-Benutzer",
    roles_menu: "Rollen",
    project_settings: "Projekteinstellungen",

    by_signing_in_you_agree_to_our: "Mit der Anmeldung stimmen Sie unseren",
    terms_and_conditions: "Allgemeinen Geschäftsbedingungen",
    and_our: "und unserer",
    privacy_policy: "Datenschutzerklärung",
    email_password: "E-Mail/Passwort",
    sign_in_with_google: "Über Google anmelden",

    // --- Auth error messages ---
    auth_user_not_found: "Benutzer nicht gefunden",
    auth_wrong_password: "Falsches Passwort. Bitte versuchen Sie es erneut.",
    auth_user_disabled: "Benutzer deaktiviert. Bitte kontaktieren Sie den Support.",
    auth_account_exists_with_different_credential: "Konto existiert mit anderer Anmeldemethode",
    auth_email_already_in_use: "Die E-Mail wird bereits verwendet",
    auth_google_permissions_required: "Sie müssen zusätzliche Berechtigungen erteilen, um Ihre Google Cloud-Projekte verwalten zu können",
    auth_invalid_email_password: "Bitte geben Sie sowohl E-Mail als auch Passwort ein",
    auth_enter_email_first: "Bitte geben Sie zuerst Ihre E-Mail ein",
    auth_password_reset_sent: "E-Mail zum Zurücksetzen des Passworts gesendet",
    auth_sign_in_account: "Melden Sie sich in Ihrem Konto an",
    auth_create_new_account: "Neues Konto erstellen",
    auth_password: "Passwort",
    auth_reset_password: "Passwort zurücksetzen",
    auth_new_user: "Neuer Benutzer?",
    auth_have_account: "Haben Sie bereits ein Konto?",
    auth_sign_in: "Anmelden",
    auth_sign_up: "Registrieren",


    auto_setup_collections_button: "Sammlungen automatisch einrichten",
    auto_setup_collections_title: "Sammlungen automatisch einrichten?",
    auto_setup_collections_desc: "Dadurch werden automatisch Sammlungskonfigurationen für Sammlungen erstellt, die noch <b>NICHT</b> zugeordnet sind.",
    this_can_take_a_minute: "Dies kann ein bis zwei Minuten dauern",
    no_collections_found_to_setup: "Keine einzurichtenden Sammlungen gefunden",
    collections_have_been_setup: "Sammlungen wurden automatisch eingerichtet",
    error_setting_up_collections: "Fehler beim automatischen Einrichten der Sammlungen",

    // --- Home Suggestions ---

    admin_panel_ready_bring_data: "Ihr Admin-Panel ist bereit. Bringen Sie Ihre Daten ein.",
    admin_panel_ready_get_started: "Ihr Admin-Panel ist bereit. So können Sie loslegen.",
    auto_detect_collections: "Sammlungen automatisch erkennen",
    auto_detect_collections_desc: "Lassen Sie die KI Ihre Datenbank scannen und Sammlungs-Schemata automatisch generieren.",
    create_a_collection: "Eine Sammlung erstellen",
    create_collection_desc: "Definieren Sie Ihre erste Sammlung manuell mit dem visuellen Editor.",
    read_the_docs: "Dokumentation lesen",
    read_the_docs_desc: "Erfahren Sie, wie Sie Felder, Ansichten, Aktionen und mehr anpassen können.",
    explore_docs: "Dokumentation erkunden",
    want_to_customize_with_code: "Möchten Sie mit Code anpassen? Führen Sie aus:",
    to_scaffold_a_local_project: "um ein lokales Projekt zu erstellen",

    // ─── Collection Editor — Validation ──────────────────────────
    validation: "Validierung",
    unique: "Einzigartig",
    required_message: "Pflichtfeld-Nachricht",
    required_tooltip: "Sie können diese Entität nicht speichern, wenn dieser Wert nicht gesetzt ist",
    unique_tooltip: "Es darf nicht mehrere Entitäten mit demselben Wert geben",
    lowercase: "Kleinbuchstaben",
    uppercase: "Großbuchstaben",
    trim: "Leerzeichen entfernen",
    exact_length: "Exakte Länge",
    min_length: "Mindestlänge",
    max_length: "Maximale Länge",
    matches_regex: "Entspricht Regex",
    not_valid_regexp: "Kein gültiger regulärer Ausdruck",
    regex_helper: "z.B. /^\\d+$/ nur für Ziffern",
    min_value: "Minimalwert",
    max_value: "Maximalwert",
    less_than: "Kleiner als",
    more_than: "Größer als",
    positive_value: "Positiver Wert",
    negative_value: "Negativer Wert",
    integer_value: "Ganzzahl",

    // ─── Collection Editor — Property Edit ───────────────────────
    invalid_regular_expression: "Ungültiger regulärer Ausdruck",
    must_specify_target_collection: "Sie müssen eine Ziel-Sammlung für das Feld angeben",
    need_specify_repeat_field: "Sie müssen ein Wiederholungsfeld angeben",
    need_specify_block_properties: "Sie müssen die Eigenschaften dieses Blocks angeben",
    incomplete_condition: "Unvollständige Bedingung – bitte wählen Sie ein Feld",
    field_name: "Feldname",

    // ─── Collection Editor — Display & Config ────────────────────
    kanban_column_property: "Kanban-Spalten-Eigenschaft",
    select_a_property: "Eigenschaft auswählen",
    kanban_property_not_found: "Eigenschaft \"{{property}}\" existiert nicht oder ist keine Enum-String-Eigenschaft. Bitte wählen Sie eine gültige Eigenschaft oder löschen Sie die Auswahl.",
    no_enum_string_properties: "Keine Enum-String-Eigenschaften gefunden. Fügen Sie eine String-Eigenschaft mit enumValues hinzu, um die Kanban-Ansicht zu verwenden.",
    kanban_column_description: "Wählen Sie eine String-Eigenschaft mit Enum-Werten, um Entitäten in Spalten zu gruppieren",
    create_property: "+ Eigenschaft \"{{property}}\" erstellen",
    order_property: "Reihenfolge-Eigenschaft",
    order_property_not_found: "Eigenschaft \"{{property}}\" existiert nicht oder ist keine Zahlen-Eigenschaft. Bitte wählen Sie eine gültige Eigenschaft oder löschen Sie die Auswahl.",
    no_number_properties: "Keine Zahlen-Eigenschaften gefunden. Fügen Sie eine Zahlen-Eigenschaft hinzu, um die Sortierung zu aktivieren.",
    order_property_description: "Wählen Sie eine Zahlen-Eigenschaft, um die Reihenfolge der Elemente beizubehalten",
    display_settings: "Anzeigeeinstellungen",
    default_row_size: "Standard-Zeilengröße",
    side_dialog_width: "Seitendialog-Breite",
    side_dialog_width_description: "Optional die Breite (in Pixeln) des Seitendialogs für Entitäten definieren. Standard ist 768px",
    inline_editing_enabled: "Daten können direkt in der Tabellenansicht bearbeitet werden",
    inline_editing_disabled: "Daten können nur in der Formularansicht bearbeitet werden",
    inline_editing_description: "Ermöglicht das direkte Bearbeiten von Daten in der Tabellenansicht, ohne die Formularansicht zu öffnen.",
    include_json_view: "JSON-Ansicht einbeziehen",
    no_json_view: "JSON-Ansicht nicht einbeziehen",
    json_view_description: "Die JSON-Darstellung des Dokuments einbeziehen.",
    not_found_suffix: "nicht gefunden",

    // ─── Editor ─────────────────────────────────────────────────
    editor_text: "Text",
    editor_text_description: "Fangen Sie einfach an, Klartext zu tippen.",
    editor_heading_1: "Überschrift 1",
    editor_heading_1_description: "Große Bereichsüberschrift.",
    editor_heading_2: "Überschrift 2",
    editor_heading_2_description: "Mittlere Bereichsüberschrift.",
    editor_heading_3: "Überschrift 3",
    editor_heading_3_description: "Kleine Bereichsüberschrift.",
    editor_todo_list: "To-Do Liste",
    editor_todo_list_description: "Verfolgen Sie Aufgaben mit einer To-Do Liste.",
    editor_bullet_list: "Aufzählungsliste",
    editor_bullet_list_description: "Erstellen Sie eine einfache Aufzählungsliste.",
    editor_numbered_list: "Nummerierte Liste",
    editor_numbered_list_description: "Erstellen Sie eine nummerierte Liste.",
    editor_quote: "Zitat",
    editor_quote_description: "Erfassen Sie ein Zitat.",
    editor_code: "Code",
    editor_code_description: "Erfassen Sie einen Code-Ausschnitt.",
    editor_image: "Bild",
    editor_image_description: "Laden Sie ein Bild hoch.",
    editor_multiple: "Mehrere",
    editor_link: "Link",
    editor_save: "Speichern",
    editor_cancel: "Abbrechen",
    editor_remove_link: "Link entfernen",
    editor_paste_or_type_link: "Link einfügen oder eintippen",
    editor_open_in_new_window: "In neuem Fenster öffnen",
    editor_bold: "Fett",
    editor_italic: "Kursiv",
    editor_underline: "Unterstrichen",
    editor_strikethrough: "Durchgestrichen",
    editor_autocomplete: "Autovervollständigung",
    editor_autocomplete_description: "Fügen Sie Text basierend auf dem Kontext hinzu.",

    // ─── Text Search Dialog ─────────────────────────────────────
    text_search_dialog_title: "Textsuche aktivieren",
    text_search_local_not_recommended: "Die lokale Textsuche wird für große Sammlungen nicht empfohlen.",
    text_search_local_fetch_warning: "Beachten Sie, dass die lokale Textsuche alle Dokumente Ihrer Sammlung abrufen und im Browser speichern muss. Dies kann bei großen Sammlungen ineffizient sein und zusätzliche Kosten verursachen.",
    text_search_external_suggestion: "Für größere Sammlungen wird empfohlen, eine externe Suchmaschine wie Algolia oder Elastic Search zu verwenden und einen Suchdelegaten in Ihrer Konfiguration zuzuweisen.",
    text_search_local_description: "Die lokale Textsuche ist der einfachste Weg, die Textsuche in Ihrer Sammlung zu aktivieren. Sie lädt alle Dokumente der Sammlung im Browser und führt die Suche lokal durch. Dies ist die empfohlene Option für kleine Sammlungen.",
    text_search_own_implementation: "Sie haben Ihren eigenen Textsuch-Controller implementiert. Sie können die Textsuche für Ihre Sammlung aktivieren.",
    text_search_enable_for_collection: "Für diese Sammlung aktivieren",
    text_search_enable_for_project: "Für das Projekt aktivieren",
    text_search_enabled_snackbar: "Lokale Textsuche aktiviert",

    settings_heading: "Einstellungen",
    settings_project_name: "Projektname",
    settings_default_language: "Standardsprache",
    settings_default_language_caption: "Wählen Sie die Basissprache für dieses Projekt. Benutzer können diese Einstellung in ihren persönlichen Einstellungen überschreiben.",
    settings_enable_local_text_search: "Lokale Textsuche aktivieren",
    settings_local_text_search_caption: "Aktivieren Sie die lokale Textsuche für alle Sammlungen. Dadurch können Sie Textfelder in Ihren Sammlungen über die Rebase-Suchleiste durchsuchen. Beachten Sie, dass diese Funktion zu höheren Lesezahlen führen kann, da alle Textfelder in Ihren Sammlungen indexiert werden.",
    settings_doc_history_all_collections: "Dokumentverlauf für alle Sammlungen aktiviert",
    settings_doc_history_caption: "Wenn aktiviert, wird der Verlauf standardmäßig für alle Sammlungen aktiviert. Sie können diese Einstellung für jede Sammlung überschreiben. Der Verlauf wird in der Untersammlung __history jedes Dokuments gespeichert.",
    settings_theme: "Design",
    settings_primary_color: "Primärfarbe",
    settings_secondary_color: "Sekundärfarbe",
    settings_sample_theme_components: "Beispiel-Designkomponenten",
    settings_drag_drop_logo: "Ziehen Sie Ihr Logo hierher",
    settings_security_rules: "Sicherheitsregeln",
    settings_security_rules_description: "Rebase verwendet Firebase-Sicherheitsregeln, um den Zugriff auf Daten einzuschränken. Beim Erstellen eines neuen Benutzers über Rebase wird dem Benutzer im Client-Projekt das benutzerdefinierte Attribut rebaseUser hinzugefügt. Durch Hinzufügen der folgenden Sicherheitsregeln stellen Sie sicher, dass Rebase-Benutzer über Rebase auf Daten zugreifen können.",
    settings_security_rules_add_domain: "Denken Sie daran, die Domain {{domain}} zu den erlaubten Domains Ihres Anbieters hinzuzufügen",
    settings_security_rules_caption: "Diese Regeln beschränken den Datenzugriff nur auf Rebase-Benutzer, setzen die Berechtigungen jedoch nicht auf Datenbankebene durch. Die Berechtigungen werden im Frontend durchgesetzt, was für die meisten Projekte ausreichend ist. Wenn Sie die Berechtigungen auf Datenbankebene durchsetzen müssen, können Sie diese Sicherheitsregeln entsprechend anpassen. Die einem Benutzer zugewiesenen Rollen werden als benutzerdefinierte Attribute im Firebase-Authentifizierungstoken gespeichert, sodass Sie sie in Ihren Sicherheitsregeln verwenden können.",

    // ─── Studio: SQL Editor ─────────────────────────────────────
    studio_sql_executing_query: "ABFRAGE WIRD AUSGEFÜHRT …",
    studio_sql_query_error: "Abfragefehler",
    studio_sql_run_query_placeholder: "Führen Sie eine Abfrage aus, um Ergebnisse zu sehen",
    studio_sql_visual_execution_plan: "Visueller Ausführungsplan",
    studio_sql_success: "SUCCESS",
    studio_sql_no_results: "Die Abfrage wurde ausgeführt, lieferte aber keine Ergebnisse.",
    studio_sql_rows: "Rows:",
    studio_sql_time: "Time:",
    studio_sql_copy_markdown: "Als Markdown kopieren",
    studio_sql_export_json: "JSON exportieren",
    studio_sql_export_csv: "CSV exportieren",
    studio_sql_format_sql: "SQL formatieren",
    studio_sql_explain: "Explain",
    studio_sql_limit_1000: "Limit 1000",
    studio_sql_remove_from_favorites: "Aus Favoriten entfernen",
    studio_sql_add_to_favorites: "Zu Favoriten hinzufügen",
    studio_sql_save: "Save",
    studio_sql_run: "Run",
    studio_sql_database: "Database",
    studio_sql_role: "Role",
    studio_sql_admin: "(Admin)",
    studio_sql_select_db: "Datenbank wählen",
    studio_sql_query_results: "Abfrageergebnisse",
    studio_sql_save_snippet: "SQL-Snippet speichern",
    studio_sql_snippet_name: "Name des Snippets",
    studio_sql_snippet_name_placeholder: "z. B. Alle Benutzer abrufen",
    studio_sql_snippet_saved_local: "Dies wird in Ihrem lokalen Speicher abgelegt.",
    studio_sql_cancel: "Cancel",
    studio_sql_dangerous_operation: "Gefährlicher Vorgang erkannt",
    studio_sql_dangerous_operation_body: "Die Abfrage, die Sie ausführen möchten, enthält potenziell zerstörerische Vorgänge (DELETE, DROP, TRUNCATE oder UPDATE ohne WHERE). Möchten Sie wirklich fortfahren?",
    studio_sql_snippet_saved: "Snippet „{{name}}“ gespeichert.",
    studio_sql_markdown_copied: "Ergebnisse als Markdown kopiert!",
    studio_sql_markdown_copy_failed: "Markdown konnte nicht in die Zwischenablage kopiert werden.",
    studio_sql_row_updated: "Zeile erfolgreich aktualisiert.",
    studio_sql_cannot_edit_missing_query: "Zeilen können nicht bearbeitet werden: Die zugrunde liegende Abfrage fehlt.",
    studio_sql_cannot_resolve_table: "Tabelle bzw. Primärschlüssel konnte nicht ermittelt werden",
    studio_sql_missing_pk: "In der Zeile fehlen die Primärschlüsselspalten: {{columns}}. Eine sichere Aktualisierung ist nicht möglich.",
    studio_sql_update_failed: "Aktualisierung fehlgeschlagen: {{message}}",
    studio_sql_execution_not_supported: "Die aktuelle Datenquelle unterstützt keine SQL-Ausführung.",
    studio_sql_error_executing: "Beim Ausführen der Abfrage ist ein Fehler aufgetreten.",
    studio_sql_error_explaining: "Beim Erklären der Abfrage ist ein Fehler aufgetreten.",
    studio_sql_save_first_to_favorite: "Bitte speichern Sie das Snippet, bevor Sie es zu den Favoriten hinzufügen.",
    studio_sql_collections_label: "Collections:",
    studio_sql_admin_collections_tooltip: "Tables in this query that are mapped as admin collections",
    studio_sql_edit_entity: "Edit {{name}} #{{id}}",
    studio_sql_sql_not_supported: "Diese Datenquelle unterstützt keine SQL-Ausführung",
    studio_sql_fetch_error: "Verbindungsoptionen konnten nicht geladen werden: {{message}}",
    studio_sql_unexpected_format: "Unerwartetes Datenformat: {{type}}",
    studio_sql_no_tables: "In dieser Datenbank wurden keine Tabellen gefunden.",
    studio_sql_schema_fetch_error: "Schema konnte nicht geladen werden: {{message}}",

    // ─── Studio: SQL Editor Sidebar ──────────────────────────────
    studio_sql_sidebar_snippets: "Snippets",
    studio_sql_sidebar_history: "History",
    studio_sql_sidebar_schema: "Schema",
    studio_sql_sidebar_no_snippets: "Keine gespeicherten Snippets",
    studio_sql_sidebar_save_snippet_hint: "Speichern Sie eine Abfrage, um sie hier wiederzufinden.",
    studio_sql_sidebar_no_history: "Kein Verlauf",
    studio_sql_sidebar_history_hint: "Ausgeführte Abfragen erscheinen hier.",
    studio_sql_sidebar_delete_snippet: "Snippet löschen",
    studio_sql_close_tab: "Diesen Abfrage-Tab schließen",
    studio_sql_new_tab: "Neuer Abfrage-Tab",

    // ─── Studio: Schema Browser ──────────────────────────────────
    studio_schema_tables: "Tables",
    studio_schema_loading: "Schema wird geladen …",
    studio_schema_no_tables: "Keine Tabellen gefunden",
    studio_schema_retry: "Retry",
    studio_schema_primary_key: "Primärschlüssel",
    studio_schema_select_all: "SELECT * FROM",
    studio_schema_insert_into: "INSERT INTO",
    studio_schema_update: "UPDATE",
    studio_schema_delete_from: "DELETE FROM",
    studio_schema_columns: "{{count}} Spalten",

    // ─── Studio: RLS Editor ──────────────────────────────────────
    studio_rls_title: "Sicherheit auf Zeilenebene",
    studio_rls_description: "RLS-Richtlinien für Ihre Tabellen verwalten",
    studio_rls_enabled: "RLS aktiviert",
    studio_rls_disabled: "RLS deaktiviert",
    studio_rls_no_rls: "Ohne RLS",
    studio_rls_enable_rls: "RLS aktivieren",
    studio_rls_disable_rls: "RLS deaktivieren",
    studio_rls_create_policy: "Richtlinie erstellen",
    studio_rls_policies: "Policies",
    studio_rls_no_policies: "Keine Richtlinien definiert",
    studio_rls_no_policies_desc: "Für diese Tabelle gibt es keine RLS-Richtlinien. Der Zugriff auf alle Zeilen richtet sich nach dem RLS-Status.",
    studio_rls_add_first_policy: "Erste Richtlinie hinzufügen",
    studio_rls_force_rls: "RLS erzwingen",
    studio_rls_force_rls_desc: "Wenn aktiviert, gelten die RLS-Richtlinien auch für den Eigentümer der Tabelle.",
    studio_rls_enable_force_rls: "Erzwungene RLS aktivieren",
    studio_rls_disable_force_rls: "Erzwungene RLS deaktivieren",
    studio_rls_edit: "Edit",
    studio_rls_delete: "Delete",
    studio_rls_confirm_delete_title: "Richtlinie löschen",
    studio_rls_confirm_delete_body: "Möchten Sie diese Richtlinie wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    studio_rls_confirm_enable_title: "Sicherheit auf Zeilenebene aktivieren",
    studio_rls_confirm_enable_body: "Mit aktivierter RLS wird der Zugriff auf Zeilen dieser Tabelle durch Ihre Richtlinien eingeschränkt. Stellen Sie sicher, dass passende Richtlinien vorhanden sind.",
    studio_rls_confirm_disable_title: "Sicherheit auf Zeilenebene deaktivieren",
    studio_rls_confirm_disable_body: "Ohne RLS sind alle Zeilen für alle Rollen zugänglich. Möchten Sie wirklich fortfahren?",
    studio_rls_select_table: "Tabelle auswählen",
    studio_rls_no_tables: "Keine Tabellen verfügbar",
    studio_rls_error: "Fehler beim Laden der Richtlinien",
    studio_rls_retry: "Retry",
    studio_rls_loading: "Richtlinien werden geladen …",

    // ─── Studio: Policy Editor ───────────────────────────────────
    studio_policy_edit: "Richtlinie bearbeiten",
    studio_policy_create: "Neue Richtlinie erstellen",
    studio_policy_defining_rules: "Zugriffsregeln festlegen für",
    studio_policy_cancel: "Cancel",
    studio_policy_save: "Richtlinie speichern",
    studio_policy_template: "Mit einer Vorlage beginnen (optional)",
    studio_policy_select_template: "Vorlage auswählen …",
    studio_policy_name: "Name der Richtlinie",
    studio_policy_name_placeholder: "Geben Sie der Richtlinie einen aussagekräftigen Namen",
    studio_policy_behavior: "Verhalten der Richtlinie",
    studio_policy_permissive: "Permissive",
    studio_policy_permissive_desc: "Wird mit „OR“ kombiniert",
    studio_policy_restrictive: "Restrictive",
    studio_policy_restrictive_desc: "Wird mit „AND“ kombiniert",
    studio_policy_command: "Befehl der Richtlinie",
    studio_policy_target_roles: "Zielrollen",
    studio_policy_roles_placeholder: "Rollen auswählen (Standard: public)",
    studio_policy_using_expr: "USING-Ausdruck",
    studio_policy_using_expr_desc: "Gilt für vorhandene Zeilen (SELECT, UPDATE, DELETE)",
    studio_policy_check_expr: "WITH CHECK-Ausdruck",
    studio_policy_check_expr_desc: "Gilt für neue oder geänderte Zeilen (INSERT, UPDATE)",
    studio_policy_help_title: "Leitfaden zur Sicherheit auf Zeilenebene (RLS)",
    studio_policy_help_intro: "Mit der Sicherheit auf Zeilenebene (RLS) legen Sie fest, welche Zeilen ein Benutzer je nach Anmeldestatus oder Rollen lesen oder ändern darf.",
    studio_policy_help_step1_title: "1. Vorlage auswählen",
    studio_policy_help_step1_desc: "Wenn RLS neu für Sie ist, beginnen Sie am einfachsten mit einer vordefinierten Vorlage aus der Liste. Sie richtet die Richtlinie für häufige Fälle wie „Benutzer dürfen ihre eigenen Zeilen ändern“ automatisch ein.",
    studio_policy_help_step2_title: "2. Zielrollen",
    studio_policy_help_step2_desc: "Wählen Sie, für welche Benutzer die Richtlinie gilt:",
    studio_policy_help_role_public: "Gilt für alle (angemeldet oder nicht).",
    studio_policy_help_role_authenticated: "Gilt nur für angemeldete Benutzer.",
    studio_policy_help_role_anon: "Gilt nur für Benutzer, die NICHT angemeldet sind.",
    studio_policy_help_step3_title: "3. USING-Ausdruck",
    studio_policy_help_step3_desc: "Eine SQL-Bedingung, die wahr sein muss, damit vorhandene Zeilen sichtbar oder änderbar sind (SELECT, UPDATE, DELETE).",
    studio_policy_help_step3_example: "Stellt sicher, dass Benutzer nur die Zeilen sehen, die ihnen gehören.",
    studio_policy_help_step4_title: "4. WITH CHECK-Ausdruck",
    studio_policy_help_step4_desc: "Eine SQL-Bedingung, die wahr sein muss, damit neue oder geänderte Zeilen gespeichert werden (INSERT, UPDATE).",
    studio_policy_help_step4_example: "Meist identisch mit dem USING-Ausdruck, wenn Benutzer nur ihre eigenen Daten anlegen oder bearbeiten dürfen.",
    studio_policy_help_auth_vars_title: "Rebase-Auth-Variablen",
    studio_policy_help_auth_vars_desc: "Rebase stellt native Hilfsfunktionen bereit, die Sie in Ihren Ausdrücken verwenden können:",
    studio_policy_help_auth_uid: "Gibt die ID des aktuellen Benutzers als Text zurück. Beispiel:",
    studio_policy_help_auth_jwt: "Gibt die vollständige JWT-Nutzlast als JSONB zurück, sodass Sie eigene Claims prüfen können. Beispiel:",
    studio_policy_help_auth_roles: "Gibt die Rollen-IDs des Benutzers als kommagetrennten Text zurück. Am besten verwendet mit:",
    studio_policy_help_docs_cta: "Mehr über Postgres-Richtlinien erfahren Sie in der offiziellen Dokumentation.",
    studio_policy_help_read_docs: "Dokumentation lesen",
    studio_policy_help_got_it: "Verstanden!",

    // ─── Studio: UI Actions ──────────────────────────────────────
    studio_add_kanban_column: "Spalte hinzufügen",
    studio_add_kanban_column_title: "Kanban-Spalte hinzufügen",
    studio_add_kanban_column_name: "Spaltenname",
    studio_add_kanban_column_name_placeholder: "Name der neuen Spalte",
    studio_add_kanban_column_add: "Add",
    studio_add_kanban_column_cancel: "Cancel",
    studio_collection_view_sql: "SQL-Editor",
    studio_collection_view_admin: "Admin-Ansicht",
    studio_editor_collection_tooltip: "Schema der Sammlung bearbeiten",
    studio_editor_collection_no_permission: "Sie haben keine Berechtigung, diese Sammlung zu bearbeiten",
    studio_editor_collection_start_tooltip: "Pfad kopieren oder Schema bearbeiten",
    studio_editor_collection_start_no_permission: "Sie haben keine Berechtigung, diese Sammlung zu ändern",
    studio_editor_collection_start_copied: "Copied!",
    studio_editor_entity_tooltip: "Schema des Eintrags bearbeiten",
    studio_editor_entity_no_permission: "Sie haben keine Berechtigung, diesen Eintrag zu bearbeiten",
    studio_home_edit_collection: "Sammlung bearbeiten",
    studio_home_delete_collection: "Sammlung löschen",
    studio_home_confirm_delete_title: "Sammlung löschen?",
    studio_home_confirm_delete_body: "Möchten Sie die Sammlung „{{name}}“ wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    studio_kanban_setup: "Kanban einrichten",
    studio_missing_reference: "Fehlende Referenz: {{path}}",
    studio_missing_reference_create: "Create",
    studio_new_collection: "Neue Sammlung",
    studio_new_collection_card: "Neue Sammlung",
    studio_new_collection_no_permission: "Sie haben keine Berechtigung, Sammlungen zu erstellen",
    studio_property_add_column: "Neue Eigenschaft hinzufügen",
    studio_property_add_column_no_permission: "Sie haben keine Berechtigung, neue Eigenschaften hinzuzufügen",
    studio_add_kanban_column_desc: "Fügt der Eigenschaft „{{property}}“ eine neue Option hinzu. Dadurch entsteht eine neue Spalte im Kanban-Board.",
    studio_add_kanban_column_adding: "Adding...",
    studio_collection_view_edit: "Edit",
    studio_editor_collection_disabled: "Das Bearbeiten von Sammlungen ist deaktiviert",
    studio_editor_collection_edit: "Sammlung bearbeiten",
    studio_editor_entity_save_first: "Sie müssen das Dokument speichern, bevor Sie das Schema ändern",
    studio_editor_entity_edit_schema: "Schema dieses Formulars bearbeiten",
    studio_editor_collection_start_save_filter: "Standardfilter und -sortierung speichern",
    studio_editor_collection_start_clear_filter: "Standardfilter und -sortierung entfernen",
    studio_editor_collection_start_reset_filter: "Auf Standardfilter und -sortierung zurücksetzen",
    studio_editor_collection_start_saved: "Standardkonfiguration gespeichert",
    studio_home_duplicate_collection: "Duplicate",
    studio_home_delete: "Delete",
    studio_home_confirm_delete_no_data: "Es werden keine Daten gelöscht, nur die Sammlung im Adminbereich",
    studio_home_collection_deleted: "Sammlung gelöscht",
    studio_kanban_configure: "Kanban konfigurieren",
    studio_missing_reference_error: "Keine Sammlung für den Pfad: {{path}}",
    studio_new_collection_add: "Neue Sammlung hinzufügen",

    // ─── Property field labels ──────────────────────────────────
    db_column_type: "Datenbank-Spaltentyp",
    primary_key_unique_id: "Primärschlüssel / Eindeutige ID",
    spread_children_as_columns: "Kinder als Spalten aufteilen",
    mode: "Modus",
    timezone: "Zeitzone",
    target_collection: "Zielsammlung",

    // ─── Storage property ───────────────────────────────────────
    storage_file_name: "Dateiname",
    storage_path: "Speicherpfad",
    storage_max_size: "Maximale Größe (in Bytes)",
    storage_resize_mode: "Größenanpassungsmodus",
    storage_output_format: "Ausgabeformat",
    storage_max_width: "Maximale Breite (px)",
    storage_max_height: "Maximale Höhe (px)",
    storage_quality: "Qualität (0-100)",
    storage_file_upload_config: "Datei-Upload-Konfiguration",
    storage_image_resize_config: "Bildgrößenanpassung",
    storage_all_file_types: "Alle Dateitypen erlaubt",
    storage_allowed_file_types: "Erlaubte Dateitypen",
    storage_include_bucket_url: "Bucket-URL (s3://...) im gespeicherten Wert einschließen",
    storage_save_url: "URL anstelle des Speicherpfads speichern",

    // ─── DateTime property ──────────────────────────────────────
    datetime_automatic_value: "Automatischer Wert",

    // ─── Markdown property ──────────────────────────────────────
    markdown_paste_behavior: "Einfügeverhalten",

    // ─── Entity identity bar and inspector ──────────────────────
    entity_saved: "Gespeichert",
    more_actions: "Weitere Aktionen",
    record_history: "Verlauf",
    inspect_record: "Datensatz inspizieren",
    inspect: "Inspizieren",
    close_inspector: "Inspektor schließen",
    open_in_live_site: "Auf der Live-Website öffnen",

    // ─── Revision history ───────────────────────────────────────
    history_revert: "Auf diese Version zurücksetzen",
    history_revert_title: "Daten auf diese Version zurücksetzen?",
    history_reverted: "Auf die gewählte Version zurückgesetzt",
    history_revert_error: "Fehler beim Zurücksetzen des Datensatzes",
    history_revert_dirty: "Bitte speichere oder verwirf deine Änderungen vor dem Zurücksetzen",
    history_empty: "Kein Verlauf vorhanden",
    history_empty_description: "Beim Speichern eines Datensatzes wird eine neue Version erstellt und im Verlauf abgelegt.",
    history_new_entity: "Der Verlauf ist nur für vorhandene Datensätze verfügbar",
    history_no_more: "Kein weiterer Verlauf",

    // ─── Studio: tools, groups and empty states ─────────────────
    // The admin's own three groups, read by `useNavigationGroupLabel` the same
    // way as the Studio ones below — the group *name* is an identifier the
    // ordering and the icons key off, and only the heading is translated.
    studio_group_views: "Ansichten",
    studio_group_admin: "Verwaltung",
    studio_group_settings: "Einstellungen",
    studio_group_database: "Datenbank",
    studio_group_compute: "Rechenleistung",
    studio_group_storage: "Speicher",
    studio_group_api: "API",
    studio_group_access_control: "Zugriffskontrolle",
    studio_tool_sql: "SQL-Konsole",
    studio_tool_sql_description: "SQL-Abfragen ausführen",
    studio_tool_js: "JS-Konsole",
    studio_tool_js_description: "JavaScript ausführen",
    studio_tool_rls: "RLS-Richtlinien",
    studio_tool_rls_description: "Sicherheit auf Zeilenebene",
    studio_tool_storage: "Speicher",
    studio_tool_storage_description: "Dateien im Speicher verwalten",
    studio_tool_cron: "Cron-Jobs",
    studio_tool_cron_description: "Geplante Aufgaben verwalten",
    studio_tool_schema_visualizer: "Schema-Visualisierung",
    studio_tool_schema_visualizer_description: "Interaktives ER-Diagramm der Datenbank",
    studio_tool_branches: "Branches",
    studio_tool_branches_description: "Datenbank-Branches erstellen und verwalten",
    studio_tool_backups: "Sicherungen",
    studio_tool_backups_description: "Datenbanksicherungen herunterladen",
    studio_tool_api: "API-Explorer",
    studio_tool_api_description: "Interaktive API-Dokumentation und Tests",
    studio_tool_logs: "Log-Explorer",
    studio_tool_logs_description: "System- und Abfrage-Logs in Echtzeit",
    studio_tool_api_keys: "API-Schlüssel",
    studio_tool_api_keys_description: "Bereichsbezogene API-Schlüssel erstellen und verwalten",
    studio_backups_denied_title: "Du darfst die Sicherungen dieses Projekts nicht auflisten",
    studio_backups_denied_hint: "Mit dem Projekt ist alles in Ordnung. Das Auflisten von Sicherungen erfordert eine Admin-Verbindung, und das angemeldete Konto wurde abgelehnt.",
    studio_backups_read_failed: "Die Sicherungen dieses Projekts konnten nicht gelesen werden",
    studio_backups_downloading: "Wird heruntergeladen…",
    studio_backups_roles_file: "Rollendatei",
    studio_backups_roles_file_hint: "Die .globals.sql, die mit dieser Sicherung gespeichert wurde. Sie legt die Datenbankrollen neu an, auf die sich die Berechtigungen und die Sicherheit auf Zeilenebene des Dumps beziehen, und `rebase db restore` liest sie neben der .dump – bewahre beide Dateien zusammen auf.",
    studio_backups_no_roles_file: "Keine Rollendatei",
    studio_backups_no_roles_file_hint: "Zu dieser Sicherung wurde keine .globals.sql gespeichert. Eine Wiederherstellung in ein neues Postgres bricht bei der ersten Berechtigung für eine Datenbankrolle ab, die dort nicht existiert.",
    studio_cron_denied_title: "Du darfst die Cron-Jobs dieses Projekts nicht auflisten",
    studio_cron_denied_hint: "Mit dem Projekt ist alles in Ordnung. Die Cron-API ist nur für Admins, und das angemeldete Konto wurde abgelehnt.",
    studio_cron_read_failed: "Die Cron-Jobs dieses Projekts konnten nicht gelesen werden",
    studio_api_keys_denied_title: "Du darfst die API-Schlüssel dieses Projekts nicht auflisten",
    studio_api_keys_denied_hint: "Mit dem Projekt ist alles in Ordnung. Das Verwalten von API-Schlüsseln ist eine Admin-Aktion, und das angemeldete Konto wurde abgelehnt.",
    studio_api_keys_read_failed: "Die API-Schlüssel dieses Projekts konnten nicht gelesen werden",
    studio_api_keys_empty_title: "Noch keine API-Schlüssel",
    studio_api_keys_empty_hint: "Erstellen Sie einen Schlüssel, um die Authentifizierung zwischen Diensten zu ermöglichen",
    studio_api_keys_revoke: "Widerrufen",
    studio_api_keys_select_hint: "Wählen Sie einen API-Schlüssel, um Details anzuzeigen",
    studio_api_keys_permissions: "Berechtigungen",
    studio_api_keys_no_permissions: "Keine Berechtigungen konfiguriert",
    studio_api_keys_revoke_confirmation: "Widerruf bestätigen",
    studio_api_keys_name_label: "Name:",
    studio_api_keys_access_label: "Zugriff:",
    studio_api_keys_admin_granted: "Admin-Rolle gewährt",
    studio_api_keys_admin_granted_hint: "die Admin-Routen und die default_admin-Richtlinien",
    studio_api_keys_done: "Fertig",
    studio_api_keys_status_active: "Aktiv",
    studio_api_keys_status_expired: "Abgelaufen",
    studio_api_keys_status_revoked: "Widerrufen",
    studio_api_keys_stat_status: "Status",
    studio_api_keys_stat_last_used: "Zuletzt verwendet",
    studio_api_keys_stat_expires: "Läuft ab",
    studio_api_keys_never: "Nie",
    studio_api_keys_role_service: "Dienst",
    studio_api_keys_stat_rate_limit: "Ratenlimit",
    studio_api_keys_rate_limit_default: "Standard (1000/15 Min.)",
    studio_api_keys_stat_created_by: "Erstellt von",
    studio_api_keys_copy_failed: "Kopieren fehlgeschlagen",
    studio_branches_denied_title: "Du darfst die Branches dieses Projekts nicht auflisten",
    studio_branches_denied_hint: "Mit dem Projekt ist alles in Ordnung. Branching läuft über die Admin-Verbindung, und das angemeldete Konto wurde abgelehnt.",
    studio_branches_read_failed: "Die Branches dieses Projekts konnten nicht gelesen werden",
    studio_schema_no_collections: "Keine Collections deklariert",
    studio_schema_no_collections_body: "Es gibt noch nichts zu zeichnen. Lege eine Collection unter config/collections/ an oder öffne „Collections bearbeiten“, um hier eine hinzuzufügen.",
    studio_schema_introspect_hint: "Bei einer Datenbank, die bereits Tabellen hat, schreibt rebase schema introspect die Collection-Dateien für dich.",


    // ─── Studio: RLS editor confirmations ───────────────────────
    studio_rls_enable_confirm_title: "Sicherheit auf Zeilenebene aktivieren?",
    studio_rls_enable_confirm_body: "Bis eine Richtlinie es erlaubt, ist jede Zeile von {{table}} unlesbar. Postgres verweigert standardmäßig.",
    studio_rls_disable_confirm_title: "Sicherheit auf Zeilenebene deaktivieren?",
    studio_rls_disable_confirm_body: "Alle Richtlinien für {{table}} werden nicht mehr durchgesetzt. Wer die Tabelle erreicht, kann jede Zeile lesen und schreiben.",
    studio_rls_drop_policy_title: "Diese Richtlinie löschen?",
    studio_rls_drop_policy_body: "{{policy}} wird in der Datenbank aus {{table}} entfernt. In den Code wird nichts geschrieben, ein Deploy kann sie also zurückbringen.",
    studio_rls_unapplied: "Nicht angewendet",
    studio_rls_unapplied_tooltip: "Im Code deklariert, aber noch nicht in der Datenbank. Hier speichern, um die Änderung zu planen und anzuwenden, oder `rebase db push` ausführen.",


    // ─── Studio: empty states that name a remedy ────────────────
    studio_branches_unavailable_title: "Datenbank-Branching ist nicht verfügbar",
    studio_branches_unavailable_body: "Branching benötigt ein Postgres-Backend mit einer Admin-Verbindung. Setze ADMIN_CONNECTION_STRING in der Umgebung des Backends.",
    studio_backups_not_configured_title: "Sicherungen sind nicht konfiguriert",
    studio_backups_not_configured_body: "Setze BACKUP_DESTINATION auf einen lokalen Pfad oder eine s3:// bzw. gs://-URL und erstelle dann eine Sicherung mit `rebase db backup` oder einem geplanten Cron-Job.",
    studio_cron_empty_title: "Keine Cron-Jobs registriert",
    studio_cron_empty_body: "Lege unter backend/crons/ eine Datei an, die eine CronJobDefinition als Default exportiert.",
    studio_read_the_docs: "Zur Dokumentation"
};
